import { rovingTabs } from '@/utils/roving-tabs';
import { createSlider, syncSlides } from '@/utils/slider';

function initSlider(panel) {
    const viewport = panel.querySelector('[data-offers-slider]');
    if (!viewport) {
        return;
    }
    if (viewport.swiper) {
        viewport.swiper.update();
        return;
    }

    const card = panel.querySelector('.home-special-offers__card');
    card?.classList.add('is-ready');

    const swiper = createSlider(viewport, {
        prev: panel.querySelector('[data-offers-prev]'),
        next: panel.querySelector('[data-offers-next]'),
        slidesPerView: 1,
        loop: true,
    });

    const reveal = () => syncSlides(viewport.querySelectorAll('[data-offers-slide]'));
    swiper.on('slideChangeTransitionEnd', reveal);

    const images = [...panel.querySelectorAll('[data-offers-image]')];
    swiper.on('slideChange', () => {
        images.forEach((image, index) => image.classList.toggle('is-active', index === swiper.realIndex));
    });

    const paint = () => {
        swiper.update();
        reveal();
    };
    paint();
    requestAnimationFrame(paint);
}

function showDestination(root, id) {
    const tabs = [...root.querySelectorAll('[data-offers-tab]')];
    const panels = [...root.querySelectorAll('[data-offers-panel]')];

    tabs.forEach((tab) => {
        const selected = tab.dataset.offersTab === String(id);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
    });

    panels.forEach((panel) => {
        const selected = panel.dataset.offersPanel === String(id);
        panel.hidden = !selected;
        if (selected) {
            initSlider(panel);
        }
    });
}

document.querySelectorAll('[data-offers]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[data-offers-tab]')];
    rovingTabs(tabs, (index) => showDestination(root, tabs[index].dataset.offersTab));

    if (tabs.length > 0) {
        const current = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
        showDestination(root, current.dataset.offersTab);
        return;
    }

    root.querySelectorAll('[data-offers-panel]').forEach((panel) => initSlider(panel));
});
